import { DropDownList } from '@syncfusion/ej2-dropdowns';

import { IndividualSmartTaskType, OrganisationSmartTaskType, SmartTaskType } from '@/shared/types/enum';

import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="smartTaskType"]')]
    .map((editable) => editable as HTMLDivElement)
    .forEach((editable) => {
      const form = editable.closest('form') as HTMLFormElement;

      const smartTaskTypeDropDownList = getControl(editable.id) as DropDownList;

      const refresh = (...smartTaskTypes: (OrganisationSmartTaskType | IndividualSmartTaskType)[]) => {
        const selected = smartTaskTypes.includes(
          smartTaskTypeDropDownList.value as OrganisationSmartTaskType | IndividualSmartTaskType,
        );

        [...form.querySelectorAll(`[data-smart-task-types="${smartTaskTypes.join(',')}"]`)]
          .map((childContainer) => childContainer as HTMLElement)
          .forEach((childContainer) => {
            childContainer.classList.toggle('d-none', !selected);

            const childEditable = childContainer.querySelector('.editable') as HTMLDivElement;

            if (childEditable) {
              (getControl(childEditable.id) as { enabled: boolean }).enabled = selected;
            }
          });
      };

      if (smartTaskTypeDropDownList) {
        refresh(SmartTaskType.BookkeepingDue);
        refresh(SmartTaskType.PayrollDue);

        smartTaskTypeDropDownList.addEventListener('change', () => {
          refresh(SmartTaskType.BookkeepingDue);
          refresh(SmartTaskType.PayrollDue);
        });
      }
    });
});
